import React, { useState } from 'react';
import { MdAdd, MdPerson, MdLocationOn, MdAssessment, MdSwapHoriz, MdVisibility, MdFileUpload, MdFileDownload, MdTrendingUp, MdSearch, MdFilterList, MdVerifiedUser } from 'react-icons/md';
import { exportRevenueOfficersToExcel } from '../../utils/excelUtils';
import OperationModal from './OperationModal';
import ExcelImportModal from './ExcelImportModal';
import OfficerActionsDropdown from './OfficerActionsDropdown';
import SetTargetsModal from './SetTargetsModal';
import ReactPaginate from 'react-paginate';
import TableLoadingWrapper from './TableLoadingWrapper';
// Import the Edit modal
import { API_BASE_URL } from '../../config/api'; 


const RevenueOfficersView = ({
  pagedFilteredData,
  allData, // Add this to get all data for export
  searchTerm,
  setSearchTerm,
  pageCount,
  handlePageClick,
  setIsAddRevenueOfficerModalOpen,
  setEditRevenueOfficer,
  setIsEditRevenueOfficerModalOpen,
  setPerformanceOfficer,
  setIsPerformanceModalOpen,
  setReassignOfficer,
  setIsReassignModalOpen,
  setViewOfficer,
  setIsViewOfficerModalOpen,
  loading,
  userRole,
  userMmdaId,
  user,
  zones, // Add zones prop
  mmdaOptions, // Add mmdaOptions prop
  showPopup, // Add showPopup prop
  fetchData, // Add fetchData prop
}) => {
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen width for responsive behavior
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Modal states
  const [showExportModal, setShowExportModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showSetTargetsModal, setShowSetTargetsModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  // const [isEditRevenueOfficerModalOpen, setIsEditRevenueOfficerModalOpen] = useState(false); // State for Edit modal
  // const [editRevenueOfficer, setEditRevenueOfficer] = useState(null); // State for officer being edited

  // Handle export with modal
  const handleExport = () => {
    const dataToExport = allData || pagedFilteredData;
    const success = exportRevenueOfficersToExcel(dataToExport, 'revenue_officers_export.xlsx');

    setShowExportModal(true);
    setTimeout(() => setShowExportModal(false), 3000); // Auto close after 3 seconds
  };

  // Handle import
  const handleImport = (result) => {
    console.log('Import result:', result);
    // Refresh data here if needed
  };

  // Handle add officer
  const handleAddOfficer = () => {
    setShowAddModal(true);
  };

  const confirmAddOfficer = () => {
    setShowAddModal(false);
    setIsAddRevenueOfficerModalOpen(true);
  };
  return (
    <>
      {/* Enhanced Revenue Officers Management Header */}
      <div style={{
        marginBottom: 24,
        padding: isMobile ? '15px 18px' : '20px 24px',
        backgroundColor: '#fff',
        borderRadius: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        border: '1px solid #f0f0f0'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          justifyContent: isMobile ? 'flex-start' : 'space-between',
          gap: isMobile ? '12px' : '0',
          marginBottom: 16
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdVerifiedUser size={24} style={{ color: '#1976d2' }} />
            <h3 style={{ margin: 0, color: '#333', fontSize: 18, fontWeight: '600' }}>
              Revenue Officers Management
            </h3>
            <span style={{
              padding: '4px 12px',
              backgroundColor: '#e3f2fd',
              color: '#1976d2',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '600'
            }}>
              {pagedFilteredData?.length || 0} Officers
            </span>
          </div>

          <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 8, width: isMobile ? '100%' : 'auto' }}>
            <button
              onClick={() => setShowSetTargetsModal(true)}
              disabled={!allData || allData.length === 0}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 6,
                padding: isMobile ? '6px 10px' : '8px 12px',
                backgroundColor: (!allData || allData.length === 0) ? '#ccc' : '#ff9800',
                color: 'white',
                border: 'none',
                borderRadius: 6,
                cursor: (!allData || allData.length === 0) ? 'not-allowed' : 'pointer',
                fontSize: isMobile ? 11 : 12,
                fontWeight: '600',
                width: isMobile ? '100%' : 'auto'
              }}
            >
              <MdTrendingUp size={16} />
              {isMobile ? 'Targets' : 'Set Targets'}
            </button>

            <button
              onClick={handleExport}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 6,
                padding: isMobile ? '6px 10px' : '8px 12px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: 6,
                cursor: 'pointer',
                fontSize: isMobile ? 11 : 12,
                fontWeight: '600',
                width: isMobile ? '100%' : 'auto'
              }}
            >
              <MdFileDownload size={16} />
              Export
            </button>

            <button
              onClick={handleAddOfficer}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 8,
                padding: isMobile ? '8px 12px' : '10px 16px',
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer',
                fontSize: isMobile ? 13 : 14,
                fontWeight: '600',
                boxShadow: '0 2px 4px rgba(40, 167, 69, 0.3)',
                transition: 'all 0.2s ease',
                width: isMobile ? '100%' : 'auto'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = '#218838';
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(40, 167, 69, 0.4)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = '#28a745';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 4px rgba(40, 167, 69, 0.3)';
              }}
            >
              <MdAdd size={18} />
              {isMobile ? 'Assign' : 'Assign Officer'}
            </button>
          </div>
        </div>

        {/* Enhanced Search Controls */}
        <div style={{ position: 'relative', maxWidth: 400 }}>
          <MdSearch size={20} style={{
            position: 'absolute',
            left: 12,
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#666'
          }} />
          <input
            type="text"
            placeholder="Search officers by name, zone, or status..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 12px 10px 40px',
              borderRadius: 8,
              border: '1px solid #ddd',
              fontSize: 14,
              outline: 'none',
              transition: 'border-color 0.2s ease',
              boxSizing: 'border-box'
            }}
            onFocus={e => e.target.style.borderColor = '#1976d2'}
            onBlur={e => e.target.style.borderColor = '#ddd'}
          />
        </div>
      </div>

      {/* Revenue Officers Table */}
      <TableLoadingWrapper loading={loading}>
        <div style={{
          overflowX: 'auto',
          position: '',
          zIndex: 1
        }}>
          <table>
            <thead>
              <tr>
                <th>Officer Name</th>
                <th>Assigned Zone</th>
                <th>Status</th>
                <th style={{ textAlign: 'center' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pagedFilteredData.map((row, i) => (
                <tr key={i} style={{
                  cursor: 'default',
                  position: 'relative',
                  zIndex: 'auto'
                }}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <strong>{row.full_name}</strong>
                    </div>
                  </td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                      <span style={{
                        padding: '4px 8px',
                        backgroundColor: '#e3f2fd',
                        borderRadius: 4,
                        fontSize: 12,
                        fontWeight: 'bold',
                        color: '#1976d2'
                      }}>
                        {row.zone_name || 'Not Assigned'}
                      </span>
                    </div>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: 4,
                      fontSize: 12,
                      fontWeight: 'bold',
                      backgroundColor: row.status === 'active' ? '#e8f5e8' : '#ffebee',
                      color: row.status === 'active' ? '#2e7d32' : '#c62828'
                    }}>
                      {(row.status || 'active').charAt(0).toUpperCase() + (row.status || 'active').slice(1)}
                    </span>
                  </td>
                  <td style={{
                    position: 'relative',
                    overflow: 'visible',
                    zIndex: 'auto'
                  }}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      position: 'relative',
                      overflow: 'visible'
                    }}>
                      <OfficerActionsDropdown
                        officer={row}
                        onView={(officer) => {
                          setViewOfficer(officer);
                          setIsViewOfficerModalOpen(true);
                        }}
                        onPerformance={(officer) => {
                          setPerformanceOfficer(officer);
                          setIsPerformanceModalOpen(true);
                        }}
                        onReassign={(officer) => {
                          setReassignOfficer(officer);
                          setIsReassignModalOpen(true);
                        }}
                        onEdit={(officer) => {
                          setEditRevenueOfficer(officer);
                          setIsEditRevenueOfficerModalOpen(true);
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </TableLoadingWrapper>

      {/* Edit Revenue Officer Modal */}


      {/* Pagination */}
      {pageCount > 1 && (
        <ReactPaginate
          previousLabel={'previous'}
          nextLabel={'next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
      )}

      {/* Officer Management Info */}
      <div style={{
        marginTop: 20,
        padding: 15,
        backgroundColor: '#e1f5fe',
        borderRadius: 8,
        border: '1px solid #b3e5fc',
        fontSize: 14,
        color: '#0277bd'
      }}>
        <strong>Revenue Officer Management:</strong> Assign and manage revenue officers within your MMDA zones.
        Officers can be assigned to specific zones and groups for efficient revenue collection operations.
      </div>

      {/* Operation Modals */}
      <OperationModal
        isOpen={showExportModal}
        onClose={() => setShowExportModal(false)}
        type="success"
        title="Export Successful!"
        message="Revenue Officers data has been exported successfully."
        details="The Excel file has been downloaded to your Downloads folder. You can now open it with Excel or any spreadsheet application."
      />

      <OperationModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        type="info"
        title="Add Revenue Officer"
        message="Are you sure you want to add a new revenue officer?"
        details="This will open the officer registration form where you can enter the officer's details and assign them to a zone."
        showCancel={true}
        confirmText="Continue"
        onConfirm={confirmAddOfficer}
      />

      <ExcelImportModal
        isOpen={showImportModal}
        onClose={() => setShowImportModal(false)}
        type="officers"
        onImport={handleImport}
        userMmdaId={userMmdaId}
        user={user}
        fetchData={fetchData}
      />

      <SetTargetsModal
        isOpen={showSetTargetsModal}
        onClose={() => setShowSetTargetsModal(false)}
        officers={allData || []}
        userMmdaId={userMmdaId}
        user={user}
      />
    </>
  );
};

export default RevenueOfficersView;
